export default "__VITE_ASSET__W4bs6Do$__"